const questionByGroup = (state, getters, rootState) => data => {
  return rootState[data.store][data.state].filter(e => e.group === data.group)
}

export default {
  questionByGroup
}